export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_COUNT = 'ADD_COUNT';
export const SUB_COUNT = 'SUB_COUNT';
export const SWITCH_CURRENCY = 'SWITCH_CURRENCY';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const CART_DATA = 'CART_DATA';
export const CLEAR_CART = 'CLEAR_CART';
export const CONVERT_TOTAL = 'CONVERT_TOTAL';
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const SET_PRODUCTS_LENGTH = 'SET_PRODUCTS_LENGTH';
export const DISPLAY_PRODUCTS_CATEGORIES = 'DISPLAY_PRODUCTS_CATEGORIES';
export const PRODUCT_PAGE = 'PRODUCT_PAGE';
